import { memo } from 'react';
import PhoneInput from 'react-phone-input-2';

import { Form } from 'antd';

import { validatePhone } from '../../helpers/validate-phone';

import messages from '../../constants/messages';

import { useUserCountry } from '../../hooks/useUserCountry';

import styles from '../../views/pages/Profile/styles.module.scss';

function PhoneField({ label, name }) {
  const userDetectedAddress = useUserCountry();

  return (
    <Form.Item
      label={label}
      name={name}
      colon={false}
      rules={[{ required: true, message: messages.FIELD_REQUIRED(label) }, validatePhone(label)]}>
      <PhoneInput
        inputClass={styles['phone-input']}
        country={userDetectedAddress?.countryCode}
        className="phone-input"
      />
    </Form.Item>
  );
}

export default memo(PhoneField);
